module.exports = __webpack_public_path__ + "img/pr-7.9d5fee4d.png";